<template>
    <div class="settings-login-page" v-loading="loading">
        <el-card shadow="never" class="settings-login-page__card">
            <el-form label-width="120px" class="settings-login-page__form">
                <el-form-item label="主标题">
                    <el-input
                        v-model.trim="form.login_page_title"
                        maxlength="120"
                        show-word-limit
                        placeholder="例如：今兔执照注销全流程管理系统"
                        :disabled="!canEdit"
                        class="settings-login-page__input"
                    />
                </el-form-item>
                <el-form-item label="副标题">
                    <el-input
                        v-model.trim="form.login_page_subtitle"
                        maxlength="200"
                        show-word-limit
                        placeholder="例如：请输入账号密码登录后台"
                        :disabled="!canEdit"
                        class="settings-login-page__input"
                    />
                </el-form-item>
                <el-form-item label="登录按钮">
                    <el-input
                        v-model.trim="form.login_page_button_label"
                        maxlength="40"
                        show-word-limit
                        placeholder="例如：登录系统"
                        :disabled="!canEdit"
                        class="settings-login-page__input-short"
                    />
                </el-form-item>
                <el-form-item label="底部提示">
                    <el-input
                        v-model.trim="form.login_page_footer_hint"
                        type="textarea"
                        :rows="3"
                        maxlength="500"
                        show-word-limit
                        placeholder="例如：演示账号说明（可为空）"
                        :disabled="!canEdit"
                        class="settings-login-page__input"
                    />
                </el-form-item>
                <el-form-item v-if="canEdit">
                    <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
                </el-form-item>
                <el-alert
                    v-if="!canEdit"
                    title="您没有快登配置编辑权限，无法修改登录页文案。"
                    type="info"
                    :closable="false"
                    show-icon
                />
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'SettingsLoginPage',
    data() {
        return {
            loading: false,
            saving: false,
            form: {
                login_page_title: '',
                login_page_subtitle: '',
                login_page_button_label: '',
                login_page_footer_hint: ''
            }
        };
    },
    computed: {
        canEdit() {
            var user = this.$store.getters.currentUser;
            if (!user) {
                return false;
            }
            if (user.is_super_admin) {
                return true;
            }
            var permissions = user.permissions || [];
            return permissions.indexOf('quick_link.edit') >= 0;
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            var _this = this;
            this.loading = true;
            window.axios.get('/branding').then(function (response) {
                var data = response.data.data || {};
                _this.form.login_page_title = data.login_page_title != null ? String(data.login_page_title) : '';
                _this.form.login_page_subtitle = data.login_page_subtitle != null ? String(data.login_page_subtitle) : '';
                _this.form.login_page_button_label = data.login_page_button_label != null ? String(data.login_page_button_label) : '';
                _this.form.login_page_footer_hint = data.login_page_footer_hint != null ? String(data.login_page_footer_hint) : '';
            }).catch(function () {
                _this.$message.error('加载登录页配置失败');
            }).finally(function () {
                _this.loading = false;
            });
        },
        handleSave() {
            if (!this.canEdit) {
                return;
            }
            var _this = this;
            this.saving = true;
            window.axios.put('/branding/login-texts', {
                login_page_title: this.form.login_page_title || '',
                login_page_subtitle: this.form.login_page_subtitle || '',
                login_page_button_label: this.form.login_page_button_label || '',
                login_page_footer_hint: this.form.login_page_footer_hint || ''
            }).then(function () {
                _this.$message.success('登录页文案已保存');
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.settings-login-page {
    padding: 0;
}

.settings-login-page__card {
    max-width: 640px;
}

.settings-login-page__form {
    max-width: 100%;
}

.settings-login-page__input {
    max-width: 520px;
}

.settings-login-page__input-short {
    max-width: 280px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsLoginPage.vue